module.exports = __webpack_public_path__ + "img/_dsc8169.d7cba706.jpg";